import { render, staticRenderFns } from "./GenericInfopanel.vue?vue&type=template&id=0ad3d92c&scoped=true&"
import script from "./GenericInfopanel.vue?vue&type=script&lang=js&"
export * from "./GenericInfopanel.vue?vue&type=script&lang=js&"
import style0 from "./GenericInfopanel.vue?vue&type=style&index=0&id=0ad3d92c&prod&lang=scss&scoped=true&"
import style1 from "./GenericInfopanel.vue?vue&type=style&index=1&id=0ad3d92c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad3d92c",
  null
  
)

export default component.exports